<template>
  <SpecialityModal
    :value="isDialogOpened"
    is-back
    :title="t('Доп. специальность', options)"
    :placeholder="t('Специальность', options)"
    title-truncate
    is-visible-reset
    :town-id="commonStore.town.id"
    :town-translit="commonStore.town.translit"
    :is-doctor-list-home="filtersStore.filters.visitLocation === 'home'"
    :is-doctor-list-online="filtersStore.filters.visitLocation === 'online'"
    :selected-speciality="filtersStore.unsavedFilters.otherSpeciality"
    :excluded-speciality="filtersStore.filters.speciality"
    @speciality:selected="onClickSpeciality"
    @speciality:reset="onReset"
    @input="handleCloseModal"
  >
    <template #footer>
      <BtnShowDoctors
        :active="isDialogOpened"
        class="pa-2 elevation-8"
        @click:submit="applySelectedPlace"
        @click:close="closeDialog"
      />
    </template>
  </SpecialityModal>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import I18NextVue from 'i18next'
import { dispatchCustomEventGlobally } from 'www/utils'
import useChipsStore from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore'
import useCommonStore from 'www/vue_components/common/TheFilters/doctors/stores/useCommonStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import updateDoctorListPage from 'www/vue_components/common/TheFilters/doctors/functions/updateDoctorListPage'
import { EVENTS as SNACKBAR_EVENTS } from 'www/vue_components/common/core/SnackbarNotification/constants'
import SpecialityModal from 'www/vue_components/common/TheFilters/doctors/components/SpecialityFilters/components/SpecialityModal.vue'
import BtnShowDoctors from 'www/vue_components/common/TheFilters/doctors/components/BtnShowDoctors/BtnShowDoctors.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const chipsStore = useChipsStore()
const commonStore = useCommonStore()
const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('OtherSpecialityFilters')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const onReset = async () => {
  closeDialog()
  filtersStore.updateFilters({ otherSpeciality: undefined })

  await updateDoctorListPage()

  dispatchCustomEventGlobally(SNACKBAR_EVENTS.open, {
    upper: true,
    message: t('Фильтр сброшен', options.value),
  })
}

watch(
  () => filtersStore.filters.otherSpeciality,
  () => {
    chipsStore.updateOtherSpecialityChip({
      name: filtersStore.filters.otherSpeciality?.name || '',
      isActive: !!filtersStore.filters.otherSpeciality?.name,
      isVisible: !!filtersStore.filters.otherSpeciality?.name,
      truncate: true,
      onClick: openDialog,
      onReset,
    })
  },
  { immediate: true },
)

const onClickSpeciality = (otherSpeciality: Filters['otherSpeciality']) => {
  filtersStore.updateUnsavedFilters({ otherSpeciality })
}

function applySelectedPlace() {
  closeDialog()
  filtersStore.applyUnsavedFilters()
  updateDoctorListPage()
}

function handleCloseModal() {
  closeDialog()
  filtersStore.resetUnsavedFilters()
}
</script>
